module.exports = __webpack_public_path__ + "static/media/nav_aboutus.c36f0d4d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/nav_aboutus.png
 ** module id = 649
 ** module chunks = 0
 **/